var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PointsViewer',{attrs:{"collname":_vm.collname}})}
var staticRenderFns = []

export { render, staticRenderFns }